import { RegulatoryOrderingKey } from "@/components/business/RegulatoryContainer/Regulatory.types";
import { invalidateRegulatoryTableDataQuery } from "@api/regulatory/regulatoryList/useRegulatoryListFilter";

import { useHandleRegulatoryTableOrdering } from "./hooks/useHandleRegulatoryTableOrdering";
import * as S from "./RegulatoryTableHead.style";
import {
  Ordering,
  TableHeaderList,
} from "../../constants/RegulatoryTable.constants";

const RegulatoryTableHead = () => {
  const { tableHeaderList, checkIsOrdering, getOrderingIcon, handleOrdering } =
    useHandleRegulatoryTableOrdering();
  const updateRegulatoryTableData = invalidateRegulatoryTableDataQuery;

  const handleClickOrdering = (
    orderingTitle: RegulatoryOrderingKey,
    ordering: Ordering,
  ) => {
    handleOrdering(orderingTitle, ordering);
    updateRegulatoryTableData();
  };

  return (
    <S.PressListTableHead>
      <S.TableRow>
        {tableHeaderList.map((item: TableHeaderList) => (
          <S.TableHeadShell
            key={`thead-${item.orderingTitle}`}
            onClick={() =>
              handleClickOrdering(
                item.orderingTitle as RegulatoryOrderingKey,
                item.ordering,
              )
            }
          >
            <S.TableHeadShellContents
              isOrdering={checkIsOrdering(item.ordering)}
            >
              <S.TableHeadShellTitle
                isOrdering={checkIsOrdering(item.ordering)}
              >
                {item.title.split("\n").map((word, wordIndex) => (
                  <S.TableHeadShellTitleWord key={word + String(wordIndex)}>
                    {word}
                  </S.TableHeadShellTitleWord>
                ))}
              </S.TableHeadShellTitle>

              <S.OrderingIconWrapper>
                {getOrderingIcon(item.ordering)}
              </S.OrderingIconWrapper>
            </S.TableHeadShellContents>
          </S.TableHeadShell>
        ))}
      </S.TableRow>
    </S.PressListTableHead>
  );
};

export default RegulatoryTableHead;
